// This file is autogenerated by injectVersion.js. Any changes will be
// overwritten on commit!
export const VERSION = '2.2.5';
